var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.desconto > 0)?_c('v-chip',{class:_vm.chipClassC,attrs:{"label":"","small":_vm.small,"color":"success"}},[_vm._v(" "+_vm._s(_vm.desconto)+"% OFF ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }